module.exports = __webpack_public_path__ + "static/img/V-S30_ar@2x.72dd41df.png";